module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"file":"ფაილი","delete":"წაშლა","save":"ატვირთვა","selectedFile":"არჩეული ფაილი","selectFile":"აირჩიე ფაილი"},"en":{"file":"File","delete":"Delete","save":"Upload","selectedFile":"Seleted File","selectFile":"Select File"}}')
  delete Component.options._Ctor
}
